/* Upper Stitch theme — small progressive enhancements.
   The design is CSS-driven; this only wires the hero preview card
   (product tabs + colour swatches) which is presentational on the homepage. */
(function () {
  function initPreview(card) {
    var garment = card.querySelector('[data-garment]');
    var colorName = card.querySelector('[data-color-name]');
    var label = card.querySelector('[data-garment-label]');

    card.querySelectorAll('[data-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        card.querySelectorAll('[data-tab]').forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        if (label) { label.textContent = tab.getAttribute('data-tab'); }
      });
    });

    card.querySelectorAll('[data-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        card.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');
        if (garment) { garment.style.background = sw.getAttribute('data-swatch'); }
        if (colorName) { colorName.textContent = sw.getAttribute('data-name'); }
      });
    });
  }

  /* Quantity stepper — used on the product page and cart lines. */
  function initQty(box, onChange) {
    var input = box.querySelector('input');
    var minus = box.querySelector('[data-qty-minus]');
    var plus = box.querySelector('[data-qty-plus]');
    if (!input) { return; }
    var min = Number(input.getAttribute('min') || 1);
    function step(delta) {
      input.value = Math.max(min, Number(input.value || min) + delta);
      if (onChange) { onChange(); }
    }
    if (minus) { minus.addEventListener('click', function () { step(-1); }); }
    if (plus) { plus.addEventListener('click', function () { step(1); }); }
  }

  /* Product page — variant picker, price, gallery, Design Studio deep link. */
  function initPDP(root) {
    var scope = root.closest('.us-pdp-page') || document;
    var dataEl = scope.querySelector('[data-pdp-variants]');
    var variants = [];
    try { variants = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) { variants = []; }

    var idInput = root.querySelector('[data-pdp-id]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var compareEl = root.querySelector('[data-pdp-compare]');
    var addBtn = root.querySelector('[data-pdp-add]');
    var addLabel = root.querySelector('[data-pdp-add-label]');
    var studioLink = root.querySelector('[data-studio-link]');
    var mainImg = root.querySelector('[data-pdp-main] img');

    // Build the Design Studio deep link for a variant:
    // <root>?variant=<encoded gid>&sku=<sku>&colour=<colour>&size=<size>
    var studioRoot = studioLink ? (studioLink.getAttribute('data-studio-root') || '') : '';
    var studioOptNames = [];
    if (studioLink) {
      try { studioOptNames = JSON.parse(studioLink.getAttribute('data-studio-optnames') || '[]'); } catch (e) { studioOptNames = []; }
    }
    function studioEnc(s) { return encodeURIComponent(s).replace(/%20/g, '+'); }
    function studioUrl(variant) {
      var params = ['variant=' + studioEnc('gid://shopify/ProductVariant/' + variant.id)];
      if (variant.sku) { params.push('sku=' + studioEnc(variant.sku)); }
      for (var k = 0; k < studioOptNames.length; k++) {
        var nm = String(studioOptNames[k] || '').toLowerCase();
        var val = variant.options[k];
        if (!val) { continue; }
        if (nm.indexOf('colour') > -1 || nm.indexOf('color') > -1) { params.push('colour=' + studioEnc(val)); }
        else if (nm.indexOf('size') > -1) { params.push('size=' + studioEnc(val)); }
      }
      return studioRoot + (studioRoot.indexOf('?') > -1 ? '&' : '?') + params.join('&');
    }

    function selectedOptions() {
      var out = [];
      root.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input:checked');
        out[Number(fs.getAttribute('data-option-index'))] = checked ? checked.value : null;
        var lbl = fs.querySelector('[data-opt-selected]');
        if (lbl && checked) { lbl.textContent = checked.value; }
      });
      return out;
    }

    function update() {
      if (!variants.length) { return; }
      var opts = selectedOptions();
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var j = 0; j < variants[i].options.length; j++) {
          if (variants[i].options[j] !== opts[j]) { match = false; break; }
        }
        if (match) { variant = variants[i]; break; }
      }

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) { addLabel.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) { idInput.value = variant.id; }
      if (priceEl) { priceEl.textContent = variant.price; }
      if (compareEl) {
        if (variant.compare_at) { compareEl.textContent = variant.compare_at; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (addBtn) { addBtn.disabled = !variant.available; }
      if (addLabel) { addLabel.textContent = variant.available ? 'Add to basket' : 'Sold out'; }
      if (studioLink) { studioLink.href = studioUrl(variant); }
      if (variant.media && mainImg) { mainImg.src = variant.media; }

      // Show only this colour's photo plus shared images (model shot, colour chart).
      var colourIndex = Number(root.getAttribute('data-colour-index'));
      var selColour = (colourIndex >= 0) ? opts[colourIndex] : null;
      root.querySelectorAll('[data-thumb]').forEach(function (btn) {
        var mc = btn.getAttribute('data-media-colour') || '';
        var show = mc === '' || selColour == null || mc === selColour;
        btn.hidden = !show;
        btn.classList.toggle('is-active', btn.getAttribute('data-thumb') === variant.media);
      });
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    root.querySelectorAll('[data-opt-input]').forEach(function (input) {
      input.addEventListener('change', update);
    });

    root.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        if (mainImg) { mainImg.src = btn.getAttribute('data-thumb'); }
      });
    });

    root.querySelectorAll('[data-qty]').forEach(function (box) { initQty(box); });
  }

  /* Cart — stepping or editing a line quantity resubmits the cart form. */
  function initCart(form) {
    var timer;
    function submitSoon() {
      clearTimeout(timer);
      timer = setTimeout(function () { form.submit(); }, 400);
    }
    form.querySelectorAll('[data-qty]').forEach(function (box) { initQty(box, submitSoon); });
    form.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', submitSoon);
    });
  }

  /* Mega nav — hover to open on desktop, keyboard accessible, click-outside/Escape to close. */
  function initNav(root) {
    var items = root.querySelectorAll('[data-nav-item]');
    if (!items.length) { return; }
    var pointer = window.matchMedia('(hover: hover) and (min-width: 861px)');

    function setOpen(item, open) {
      var panel = item.querySelector('[data-nav-panel]');
      var toggle = item.querySelector('[data-nav-toggle]');
      item.classList.toggle('is-open', open);
      if (panel) { panel.hidden = !open; }
      if (toggle) { toggle.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    }
    function closeAll(except) {
      items.forEach(function (it) { if (it !== except) { setOpen(it, false); } });
    }

    // Close on a short delay so moving the pointer across the gap into the
    // panel (which re-fires mouseenter) doesn't slam it shut first.
    var closeTimer = null;
    function openItem(item) {
      clearTimeout(closeTimer);
      closeAll(item);
      setOpen(item, true);
    }
    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { closeAll(null); }, 220);
    }

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-nav-toggle]');
      item.addEventListener('mouseenter', function () { if (pointer.matches) { openItem(item); } });
      item.addEventListener('mouseleave', function () { if (pointer.matches) { scheduleClose(); } });
      if (!toggle) { return; }
      toggle.addEventListener('focus', function () { if (pointer.matches) { openItem(item); } });
      toggle.addEventListener('click', function (e) {
        // Button toggles in place; a linked top (anchor) is left to navigate.
        if (toggle.tagName === 'BUTTON') {
          e.preventDefault();
          var willOpen = !item.classList.contains('is-open');
          clearTimeout(closeTimer);
          closeAll(item);
          setOpen(item, willOpen);
        }
      });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeAll(null); } });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) { closeAll(null); } });
  }

  /* Mobile drawer — the burger and the in-drawer close button share [data-nav-burger]. */
  function initMobileNav() {
    var drawer = document.querySelector('[data-nav-mobile]');
    if (!drawer) { return; }
    var burgers = document.querySelectorAll('[data-nav-burger]');
    burgers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var willOpen = drawer.hidden;
        drawer.hidden = !willOpen;
        document.body.style.overflow = willOpen ? 'hidden' : '';
        var opener = document.querySelector('.us-navburger');
        if (opener) { opener.setAttribute('aria-expanded', willOpen ? 'true' : 'false'); }
      });
    });
  }

  /* Collection description — clamp to a few lines with a Read more toggle,
     and size the square hero image to the clamped text height (side-by-side only). */
  function initCollectionDesc() {
    var desc = document.querySelector('[data-collection-desc]');
    var toggle = document.querySelector('[data-desc-toggle]');
    var img = document.querySelector('.us-cat-hero-img');
    var text = document.querySelector('.us-cat-hero-text');

    function sizeImage() {
      if (!img || !text) { return; }
      img.style.width = '';
      img.style.height = '';
      // Only match height when the image sits beside the text (not stacked/wrapped).
      if (Math.abs(img.offsetTop - text.offsetTop) > 4) { return; }
      // Always measure the clamped ("before Read more") height.
      var reExpand = desc && !desc.classList.contains('is-clamped') && !toggle.hidden;
      if (reExpand) { desc.classList.add('is-clamped'); }
      var h = text.offsetHeight;
      if (reExpand) { desc.classList.remove('is-clamped'); }
      if (h > 0) { img.style.width = h + 'px'; img.style.height = h + 'px'; }
    }

    if (desc && toggle) {
      desc.classList.add('is-clamped');
      if (desc.scrollHeight - desc.clientHeight > 6) {
        toggle.hidden = false;
        toggle.addEventListener('click', function () {
          var clamped = desc.classList.toggle('is-clamped');
          toggle.textContent = clamped ? 'Read more' : 'Read less';
        });
      } else {
        desc.classList.remove('is-clamped');
      }
    }

    sizeImage();
    window.addEventListener('resize', sizeImage);
  }

  /* Header search overlay. */
  function initSearch() {
    var panel = document.querySelector('[data-search-panel]');
    var toggles = document.querySelectorAll('[data-search-toggle]');
    if (!panel || !toggles.length) { return; }
    var input = panel.querySelector('[data-search-input]');
    function setOpen(open) {
      panel.hidden = !open;
      toggles.forEach(function (t) { if (t.hasAttribute('aria-expanded')) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); } });
      if (open && input) { setTimeout(function () { input.focus(); }, 30); }
    }
    toggles.forEach(function (t) { t.addEventListener('click', function () { setOpen(panel.hidden); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setOpen(false); } });
    document.addEventListener('click', function (e) {
      if (!panel.hidden && !panel.contains(e.target) && !e.target.closest('[data-search-toggle]')) { setOpen(false); }
    });
  }

  /* Search results page — focus the search box, cursor at the end. */
  function initSearchPage() {
    var input = document.querySelector('[data-search-page-input]');
    if (!input) { return; }
    setTimeout(function () {
      input.focus({ preventScroll: true });
      var len = input.value.length;
      try { input.setSelectionRange(len, len); } catch (e) {}
    }, 60);
  }

  /* Favourites — a per-device wishlist stored in localStorage. */
  var WL_KEY = 'us_wishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; } }
  function wlSet(a) { try { localStorage.setItem(WL_KEY, JSON.stringify(a)); } catch (e) {} }
  function wlToggle(h) { var a = wlGet(); var i = a.indexOf(h); if (i > -1) { a.splice(i, 1); } else { a.push(h); } wlSet(a); }
  function wlSyncUI() {
    var items = wlGet();
    document.querySelectorAll('[data-wl-count]').forEach(function (b) { b.textContent = items.length; b.hidden = items.length === 0; });
    document.querySelectorAll('[data-wl-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-saved', items.indexOf(btn.getAttribute('data-wl-handle')) > -1);
    });
  }
  function wlRenderDrawer() {
    var body = document.querySelector('[data-wl-body]');
    if (!body) { return; }
    var items = wlGet();
    if (!items.length) { body.innerHTML = '<p class="us-wl-empty">No favourites yet. Tap the heart on any product to save it here.</p>'; return; }
    body.innerHTML = '<p class="us-wl-empty">Loading&hellip;</p>';
    Promise.all(items.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      var html = prods.filter(Boolean).map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        if (img && img.indexOf('?') === -1) { img += '?width=140'; }
        return '<div class="us-wl-item">' +
          '<a class="us-wl-link" href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="" width="56" height="56" loading="lazy">' : '<span class="us-wl-noimg"></span>') +
          '<span class="us-wl-info"><span class="t">' + p.title + '</span><span class="p">from &pound;' + (p.price / 100).toFixed(2) + '</span></span>' +
          '</a>' +
          '<button type="button" class="us-wl-remove" data-wl-toggle data-wl-handle="' + p.handle + '" aria-label="Remove">&times;</button>' +
          '</div>';
      }).join('');
      body.innerHTML = html || '<p class="us-wl-empty">No favourites yet.</p>';
    });
  }
  function initWishlist() {
    var drawer = document.querySelector('[data-wishlist-drawer]');
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wl-toggle]');
      if (!btn) { return; }
      e.preventDefault();
      e.stopPropagation();
      wlToggle(btn.getAttribute('data-wl-handle'));
      wlSyncUI();
      if (drawer && !drawer.hidden) { wlRenderDrawer(); }
    });
    var openBtn = document.querySelector('[data-wishlist-toggle]');
    if (openBtn && drawer) {
      openBtn.addEventListener('click', function () { wlRenderDrawer(); drawer.hidden = false; document.body.style.overflow = 'hidden'; });
      drawer.querySelectorAll('[data-wishlist-close]').forEach(function (c) {
        c.addEventListener('click', function () { drawer.hidden = true; document.body.style.overflow = ''; });
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) { drawer.hidden = true; document.body.style.overflow = ''; } });
    }
    wlSyncUI();
  }

  document.addEventListener('DOMContentLoaded', function () {
    initCollectionDesc();
    document.querySelectorAll('[data-preview-card]').forEach(initPreview);
    document.querySelectorAll('[data-pdp]').forEach(initPDP);
    document.querySelectorAll('[data-cart-form]').forEach(initCart);
    document.querySelectorAll('[data-nav-root]').forEach(initNav);
    initMobileNav();
    initSearch();
    initSearchPage();
    initWishlist();
  });
})();
